import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "gatsby";
import {
  AndroidGameIcon,
  ArVrIcon,
  IphoneGameIcon,
  WebGameIcon,
} from "../../../app-constants";

function GameServices(props) {
  return (
    <section className="game_servies p50">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6}>
            <h2>TekRevol’s Versatile Mobile Game Development Services</h2>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Build Your Game App
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} className="offset-xl-1">
            <p className="game_para">
              Our mobile game development services are designed to build games
              for diverse OS and screens. Our platform-centric approach provides
              users with the purest and most unforgettable gaming experience. We
              know our clients expect nothing but a highly engaging, quality
              user experience from what we create, so we deliver exactly
              that.Here are the mobile game development services that TekRevol
              offers:
            </p>
          </Col>
        </Row>
        <Row className="services_main_container">
          <Col xs={12} md={6} lg={3}>
            <div className="services_main_box">
              <div className="services_title">
                <div className="services_icon">{AndroidGameIcon}</div>
                <div className="title">
                  Android Game <br />
                  Development
                </div>
              </div>
              <div className="services_content">
                <p>
                  TekRevol stands out as a preferred choice among the best
                  mobile game development companies, focusing on delivering
                  exceptional Android game development services. We breathe life
                  into your gaming concepts, customizing them to seamlessly
                  integrate with the Android ecosystem. Our dedicated team,
                  well-versed in the technical complexities of Android,
                  guarantees a fluid and captivating user experience. Hire us to
                  use our Android game development services to build
                  multiplayer, battle royale, and RPG Android games for users.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={3}>
            <div className="services_main_box">
              <div className="services_title">
                <div className="services_icon">{IphoneGameIcon}</div>
                <div className="title">
                  iPhone Game <br />
                  Development
                </div>
              </div>
              <div className="services_content">
                <p>
                  As a leading game app development company, TekRevol employs
                  state-of-the-art technology and technical expertise to
                  transform your gaming concepts into reality on iOS devices.
                  Our iPhone app development services provide smooth and
                  engaging user experiences, positioning us as a frontrunner in
                  iOS game development. Join us to use our iOS game development
                  services to build real-time, interactive games for iPhone and
                  tablet users.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={3}>
            <div className="services_main_box">
              <div className="services_title">
                <div className="services_icon">{WebGameIcon}</div>
                <div className="title">
                  Web Game <br />
                  Development
                </div>
              </div>
              <div className="services_content">
                <p>
                  TekRevol stands at the forefront of gaming enterprises,
                  featuring a team that merges technical proficiency with
                  creative ingenuity to produce compelling games accessible
                  directly through your web browser. Utilizing cutting-edge
                  technologies, we guarantee a seamless and immersive gaming
                  encounter, pushing the limits of what web-based games can
                  accomplish. Hire us to use our web game development services
                  to build highly addictive and real-time games for web
                  browsers.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={3}>
            <div className="services_main_box">
              <div className="services_title">
                <div className="services_icon">{ArVrIcon}</div>
                <div className="title">
                  AR/VR <br />
                  Game
                </div>
              </div>
              <div className="services_content">
                <p>
                  As a prominent game development company, TekRevol excels in
                  the domain of AR/VR game development, where innovation
                  converges with reality. Our skilled team utilizes advanced
                  technologies to craft enthralling and realistic gaming
                  experiences, pushing the limits of what can be achieved.
                  Emphasizing seamless interactivity and immersive storytelling,
                  TekRevol turns your gaming concepts into virtual realities
                  that captivate audiences. Hire us to use our AR/VR game
                  development services to build multiplayer virtual environment
                  games like Pokemon Go.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default GameServices;
